export default __webpack_public_path__ + "static/media/pelota-tenis.54398524.png";